// extracted by mini-css-extract-plugin
export default {"baseMoney":"FOnit","isFat":"xhhA1","customCurrencyIcon":"Gbhhj","skeleton-progress":"R0F5Q"};